module.exports = __webpack_public_path__ + "img/2023_trial_jr_banner.af01ce36.png";